/**
 * Shooting Config Loader
 *
 * Loads dice throwing configuration from localStorage (shared with editor)
 * Falls back to defaults if no preset is saved
 */

export interface ShootingConfig {
  holdHeight: number;
  energyGain: number;
  maxPower: number;
  baseForward: number;
  lobStrength: number;
  lobDuration: number;
  diceMass: number;
}

export interface ShootingPreset {
  id: string;
  name: string;
  isDefault: boolean;
  config: ShootingConfig;
}

const DEFAULT_SHOOTING_CONFIG: ShootingConfig = {
  holdHeight: 4,
  energyGain: 0.3,
  maxPower: 60,
  baseForward: 5,
  lobStrength: 1.0,
  lobDuration: 0.2,
  diceMass: 1.0,
};

const STORAGE_KEY = 'sdl-editor-shooting-presets';

/**
 * Load the default shooting config from localStorage
 * Returns the preset marked as default, or falls back to hardcoded defaults
 */
export function loadDefaultShootingConfig(): ShootingConfig {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const presets: ShootingPreset[] = JSON.parse(stored);
      const defaultPreset = presets.find((p) => p.isDefault);
      if (defaultPreset) {
        console.log('[ShootingConfig] Loaded default preset:', defaultPreset.name);
        return { ...DEFAULT_SHOOTING_CONFIG, ...defaultPreset.config };
      }
    }
  } catch (e) {
    console.warn('[ShootingConfig] Failed to load presets:', e);
  }

  console.log('[ShootingConfig] Using hardcoded defaults');
  return { ...DEFAULT_SHOOTING_CONFIG };
}

/**
 * Get the hardcoded default config (for reset functionality)
 */
export function getHardcodedDefaults(): ShootingConfig {
  return { ...DEFAULT_SHOOTING_CONFIG };
}
